module.exports = __webpack_public_path__ + "static/media/lora.1add7a5a.jpg";